export const SET_DIRECCION_ENVIO = 'SET_DIRECCION_ENVIO';

